"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ListContext: true
};
exports.default = exports.ListContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _ListContext = require("./_ListContext.types");
Object.keys(_ListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListContext[key];
    }
  });
});
const ListContext = exports.ListContext = /*#__PURE__*/_react.default.createContext({});
var _default = exports.default = ListContext;